import script from "./FavoriteDrivers.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoriteDrivers.vue?vue&type=script&setup=true&lang=js"

import "./FavoriteDrivers.vue?vue&type=style&index=0&id=1b0ae8ac&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/set-repository-web-glasses/glasses-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b0ae8ac"]])

export default __exports__